var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useRef } from 'react';
import { Popover } from '@headlessui/react';
import Draggable from 'react-draggable';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { store, useAppSelector } from '../../../store';
import InterimTextElms from './interimTextElms';
const lastFinalTextsSelector = createSelector(_react_refresh_temp_1 = (state) => state.speechServices, (speechServices) => speechServices.lastFinalTexts);
$RefreshReg$(_react_refresh_temp_1, "lastFinalTextsSelector$createSelector");
const PopoverPanelElms = ({ showPopover, setShowPopover, }) => {
    _react_refresh_temp_3();
    const { t } = useTranslation();
    const lastFinalTexts = useAppSelector(lastFinalTextsSelector);
    const nodeRef = useRef(null);
    const downloadTexts = useCallback(() => {
        if (!lastFinalTexts.length) {
            return;
        }
        const texts = lastFinalTexts.map((t) => {
            return `${t.time} ${t.from}:\n${t.text}`;
        });
        const lang = store.getState().speechServices.selectedSubtitleLang;
        const formBlob = new Blob([texts.join('\n\n')], {
            type: 'text/plain;charset=UTF-8',
        });
        const link = document.createElement('a');
        link.setAttribute('href', window.URL.createObjectURL(formBlob));
        link.setAttribute('download', `subtitle_texts_${lang}.txt`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }, [lastFinalTexts]);
    return (_jsx(Draggable, { nodeRef: nodeRef, children: _jsxs(Popover.Panel, { className: "SpeechHistory absolute left-0 z-10 mx-1 bottom-14 w-full max-w-md bg-white dark:bg-darkPrimary shadow-xl rounded-2xl h-ful", ref: nodeRef, static: showPopover, children: [_jsxs("h2", { className: "relative text-lg font-medium leading-6 text-gray-900 dark:text-white p-5 pb-3 px-3 cursor-move", children: [t('speech-services.subtitle-history-modal-title'), _jsx("button", { className: "absolute ltr:right-10 rtl:left-10 w-[25px] h-[25px] outline-none", onClick: () => downloadTexts(), children: _jsx("i", { className: "pnm-download" }) }), _jsx("button", { className: "absolute top-7 ltr:right-3 rtl:left-3 w-[25px] h-[25px] outline-none", onClick: () => setShowPopover(!showPopover), children: _jsx("span", { className: "inline-block h-[2px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 -rotate-0" }) })] }), _jsx("hr", {}), _jsxs("div", { className: "p-3 pb-8 text-primary dark:text-white h-[200px] overflow-hidden overflow-y-auto scrollBar scrollBar4", children: [lastFinalTexts.slice(-50).map((t) => {
                            return (_jsxs("div", { className: "sentence w-full pt-2", children: [_jsxs("p", { className: "date text-sm pb-1 primaryColor dark:text-darkText", children: [_jsx("span", { className: "text-xs", children: t.time }), " ", t.from, ":"] }), _jsx("p", { className: "message-content max-w-fit shadow-footer text-sm bg-secondaryColor text-white py-1 px-2 rounded", children: t.text })] }, t.id));
                        }), _jsx(InterimTextElms, {})] })] }) }));
};
_react_refresh_temp_2 = PopoverPanelElms;
$RefreshReg$(_react_refresh_temp_2, "PopoverPanelElms");
_react_refresh_temp_3(PopoverPanelElms, "qaeYUzIvXQzpCgvEDQZJAj9hEd4=", false, () => [useTranslation, useAppSelector]);
export default PopoverPanelElms;
